import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layouts/loader/Loadable";
import AuthGuard from "../components/authGurad/AuthGuard";
import CONFIGURATORE_RISERVE_ENABLED from "../views/configuratoreRiserve/configuratoreRiserve.flags";


/****Layouts*****/
const HomeLayout = Loadable(lazy(() => import("../layouts/HomeLayout")));
const BlankLayout = Loadable(lazy(() => import("../layouts/BlankLayout")));
//***** Pages ****/
const GridTask = Loadable(lazy(() => import("../views/GridTask")));
const DetailTask = Loadable(lazy(() => import("../views/dettaglio-task/DetailTask")));
const Ws = Loadable(lazy(() => import("../views/Ws")));
const ConfiguratoreRiserve = Loadable(lazy(() => import("../views/configuratoreRiserve/ConfiguratoreRiserve")));
const GestioneFiduciari = Loadable(lazy(() => import("../views/gestioneFiduciari/GestioneFiduciari")));
const ConfigurazioneAssegnazione = Loadable(lazy(() => import("../views/configurazioneAssegnazione/ConfigurazioneAssegnazione")));
/***** Auth Pages ****/
/***** Auth Pages ****/
const OnError = Loadable(lazy(() => import("../views/auth/Error")));
const Register = Loadable(lazy(() => import('../views/auth/Register')));
const FormLogin = Loadable(lazy(() => import('../components/forms/form_login/FormLogin')));
const DescopeLoginFlow = Loadable(
  lazy(() =>
    import('../components/descope/component/descopeLoginFlow').then((m) => ({ default: m.DescopeLoginFlow }))
  )
);
/*****Routes******/
const ThemeRoutes = [
  {
    path: "/",
    element: (
      <AuthGuard>
        <HomeLayout />
      </AuthGuard>
    ),
    children: [
      { path: "/", element: <Navigate to="/auth/login" /> },
      { path: "/home", element: <GridTask /> },
      { path: "/configuratore-riserve", element: CONFIGURATORE_RISERVE_ENABLED ? <ConfiguratoreRiserve /> : <Navigate to="/home" /> },
      { path: "/gestione-fiduciari", element: <GestioneFiduciari /> },
      { path: "/configurazione-assegnazione", element: <ConfigurazioneAssegnazione /> },
      { path: `/task/:id`, element: <DetailTask idTask="/task-:id"/> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: "/auth",
    element: <BlankLayout />,
    children: [
      { path: '404', element: <OnError /> },
      { path: 'register', element: <Register /> },
      { path: 'login', element: (process.env.REACT_APP_SSO_LOGIN_DESCOPE_ENABLED === 'true') ? <DescopeLoginFlow /> : <FormLogin /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: "/ws",
    element: <BlankLayout />,
    children: [
      { path: "ws-:id", element: <Ws id=":id" /> }
    ],
  },
];

export default ThemeRoutes;
